import Button from '@mui/material/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useContext, useState } from 'react';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import NRAssetsActions from '../../pages/NRAssetsActions/NRAssetsActions';
import Box from '@mui/material/Box';

function NRSummaryActions() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { asset } = useContext(ComponentContext);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box ml={2} alignSelf="center" mt={'-10px'}>
      <Button
        sx={{ textTransform: 'unset', fontWeight: 600 }}
        id="actions-button"
        aria-controls={open ? 'actions-button-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="outlined"
        color="secondary"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <NRAssetsActions component={asset} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </Box>
  );
}

export default NRSummaryActions;
